import AddReactionIcon from "@mui/icons-material/AddReaction";
import { IconButton } from "@mui/material";
import React, { useState } from "react";
import Picker, { Emoji } from "emoji-picker-react";

/**
 * EmojiPicker - A reusable emoji picker component
 *
 * @param {string} emoji - Currently selected emoji (unified code)
 * @param {function} setEmoji - Callback when an emoji is selected
 * @param {number} size - Size of the emoji icon in pixels. Defaults to 40
 */
const EmojiPicker = ({ setEmoji, emoji, size = 40 }) => {
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [emojiIcon, setEmojiIcon] = useState(emoji);

  return (
    <div className="emoji-picker">
      <IconButton
        className="emoji-picker_emoji-icon-container"
        onClick={() => setSelectorOpen(!selectorOpen)}
        sx={{ flexShrink: 0 }}
      >
        {emojiIcon ? (
          <Emoji unified={emojiIcon} set="apple" size={size} />
        ) : (
          <AddReactionIcon
            className="emoji-picker_emoji-icon"
            sx={{ width: size, height: size }}
          />
        )}
      </IconButton>
      {selectorOpen && (
        <Picker
          className={"emoji-picker_selector"}
          onEmojiClick={(emojiObject, event) => {
            setEmoji(emojiObject.unified);
            setEmojiIcon(emojiObject.unified);
            setSelectorOpen(false);
          }}
          height={350}
          width={320}
        />
      )}
    </div>
  );
};

export default EmojiPicker;
